import React from 'react';
import { AreaChart } from 'lucide-react';
import { BoxProps } from '@mantine/core';
import { IconWrapper } from './IconWrapper';

interface AreaChartIconProps extends BoxProps {
    size?: number;
    color?: string;
}

export const AreaChartIcon: React.FC<AreaChartIconProps> = ({ size = 32, color, ...props }) => {
    return (
        <IconWrapper size={size} {...props}>
            <AreaChart size={size} color={color} />
        </IconWrapper>
    );
};
